import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GalleryTheme } from '@nusign/picflow-backend-types';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-made-with-picflow-button',
  templateUrl: './made-with-picflow-button.component.html',
  styleUrls: ['./made-with-picflow-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective, SvgComponent],
})
export class MadeWithPicflowButtonComponent {
  readonly tenantId = input<string>(undefined);
  readonly theme = input<GalleryTheme>(undefined);
}
